import * as types from 'legacy-src/constants/types';

const secureAssignmentIds = (state = {}, action) => {
  switch (action.type) {
    case types.SET_SECURE_ASSIGNMENT_IDS:
      return action.secureAssignmentIds || {};
    default:
      return state;
  }
};

export default secureAssignmentIds;
